import { render, staticRenderFns } from "./CellularData.vue?vue&type=template&id=22c9c073&scoped=true&"
import script from "./CellularData.vue?vue&type=script&lang=js&"
export * from "./CellularData.vue?vue&type=script&lang=js&"
import style0 from "./CellularData.vue?vue&type=style&index=0&id=22c9c073&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9c073",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c9c073')) {
      api.createRecord('22c9c073', component.options)
    } else {
      api.reload('22c9c073', component.options)
    }
    module.hot.accept("./CellularData.vue?vue&type=template&id=22c9c073&scoped=true&", function () {
      api.rerender('22c9c073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/CellularData.vue"
export default component.exports